import api, { apiSetup } from '../api';

apiSetup();

export class ProjectService {
  BASE_URL = '/projects';

  // get_choices() {
  //     return api.get(`${this.BASE_URL}/get_choices`);
  // }

  get_chart_data(filters = {}) {
    const queryParams = new URLSearchParams();

    // Add filters to query string if they exist
    if (filters.iirsa_countries && filters.iirsa_countries.length > 0) {
      queryParams.append('iirsa_countries', filters.iirsa_countries.join(','));
    }
    if (filters.iirsa_stage) {
      queryParams.append('iirsa_stage', filters.iirsa_stage);
    }

    const queryString = queryParams.toString();
    const url = queryString ? `${this.BASE_URL}/get_chart_data/?${queryString}` : `${this.BASE_URL}/get_chart_data/`;

    return api.get(url);
  }

  get_projects_list_extra_data(filters) {
    return api.get(`${this.BASE_URL}/index_extra_data/${filters}`);
  }
}
